import { ICompanyAlertEmailSettings } from './company-alert-email-settings.interface';

export class CompanyAlertEmailSettings implements ICompanyAlertEmailSettings {
  companySettingsId: string;//Array<string> = [];
  companyId: string;
  personName: string;
  email: string;
  constructor(iCompanyAlertSettings: ICompanyAlertEmailSettings = null) {
    this.companySettingsId = iCompanyAlertSettings?.companySettingsId;// ?? [];
    this.companyId = iCompanyAlertSettings?.companyId;
    this.personName = iCompanyAlertSettings?.personName;
    this.email = iCompanyAlertSettings?.email;
  }
}

